function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_141",
  "data-name": "Group 141",
  transform: "translate(-647 -5201)"
}, React.createElement("g", {
  id: "Group_40",
  "data-name": "Group 40",
  transform: "translate(647.37 5205.798)"
}, React.createElement("path", {
  id: "Path_35",
  "data-name": "Path 35",
  d: "M242.569,113.075c-3.056,0-5.5-1.37-6.149-4.321-.75-3.38-1.113-6.937.568-10.265a6.7,6.7,0,0,1,2.736-2.635c1.17-.7,1.915-1.537,1.652-3.022-.091-.516.115-1.079.043-1.6-.033-.263-.391-.477-.606-.711-.172.243-.516.506-.492.73.248,2.23-1.088,3.352-2.869,4.115a18.1,18.1,0,0,1-3.122,1.027,3.308,3.308,0,0,1-2.831-.664,3.114,3.114,0,0,1,.32-5.156,23.154,23.154,0,0,1,4.292-2.01,35.486,35.486,0,0,1,11.831-2.029,56.706,56.706,0,0,1,7.338.582,26.861,26.861,0,0,1,9.119,2.826,5.029,5.029,0,0,1,2.024,1.786c1.361,2.3-.282,4.86-3.056,4.7a8.711,8.711,0,0,1-5.548-2.344,2.774,2.774,0,0,1-.95-2.483.973.973,0,0,0-.038-.6,1.051,1.051,0,0,0-.6-.454c-.115-.019-.368.3-.43.5a2.277,2.277,0,0,0,0,.764,4.252,4.252,0,0,1,.081,1.217c-.339,1.4.425,2.1,1.485,2.745a7.63,7.63,0,0,1,3.423,3.815c.544,1.432.6,7.854.048,9.257a6.2,6.2,0,0,1-6.207,4.24C253.607,113.047,244.54,113.071,242.569,113.075Zm6-6.908a8.375,8.375,0,0,0,6-2.449,4.154,4.154,0,0,0,.458-5.6,6.363,6.363,0,0,0-3.07-2.32,8.587,8.587,0,0,0-9.148,1.576,4.3,4.3,0,0,0-.043,6.474A8.492,8.492,0,0,0,248.565,106.167Zm.076-16.295v0c-1.05,0-2.1.019-3.142-.01-.659-.014-.945.277-.931.917a4,4,0,0,0,0,.535c.043.258.129.511.191.764a3.394,3.394,0,0,0,.745-.286,6.352,6.352,0,0,1,6.211.029,3.622,3.622,0,0,0,.74.291c.067-.282.153-.559.191-.84a3.428,3.428,0,0,0-.029-.535c-.024-.64-.344-.9-.984-.878C250.632,89.891,249.639,89.872,248.642,89.872Z",
  transform: "translate(-230.278 -86.53)",
  fill: "#2c3e50"
}), React.createElement("path", {
  id: "Path_36",
  "data-name": "Path 36",
  d: "M237.681,94.867a5.217,5.217,0,0,1-3.361-1.055,2.519,2.519,0,0,1,.019-4.1,4.835,4.835,0,0,1,5.777-.086,2.6,2.6,0,0,1-.4,4.545A11.155,11.155,0,0,1,237.681,94.867Z",
  transform: "translate(-218.959 -78.286)",
  fill: "#2c3e50"
})), React.createElement("rect", {
  id: "Rectangle_30",
  "data-name": "Rectangle 30",
  width: 37,
  height: 37,
  transform: "translate(647 5201)",
  fill: "none",
  opacity: 0.37
}));

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.fe5f312e.svg";
export { ForwardRef as ReactComponent };